import React, { useContext, useEffect, useState } from 'react';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { useNotifications } from '../contexts/notificationsContext';
import { MessageDto } from '../DashboardApi/api';
import { REACT_APP_PORTAL_API_URL } from '../../KeyVariables';
import AuthService from '../JWThelper'
import { showNotificationInBrowser } from '../helpers/notificationHelper/notificationHelper';
interface Message {
    communicationMessageUserId: number;
    subject: string;
    body: string;
    email: string;
}

const MessageReceiver: React.FC = () => {
    const [connection, setConnection] = useState<HubConnection | null>(null);
    const [messages, setMessages] = useState<MessageDto[]>([]);
    const notification = useNotifications();
    useEffect(() => {
        notification.addNotification(messages, false)
    }, [messages])
    const person = AuthService.getCurrentUserPersonId();

    return (
        <div>
            {/* <h2>Received Messages</h2>
            <ul>
                {messages.map((msg, index) => (
                    <li key={index}>
                        <strong>Subject:</strong> {msg.subject} <br />
                        <strong>Message:</strong> {msg.body} <br />
                        <strong>From:</strong> {msg.email}
                    </li>
                ))}
            </ul> */}
        </div>
    );
};

export default MessageReceiver;